export default __webpack_public_path__ + "static/media/slime_condensate.43fee874.png";